import ReactMarkdown from 'react-markdown';

import './Markup.css';

/**
 * Render TestRail-style markup (a Markdown variant) safely, with the
 * Bootstrap layout's spacing in mind. We strip \r so Windows line
 * endings don't break list parsing, and the wrapping CSS class kills
 * the default top/bottom margin on the first/last block element so
 * the field doesn't push the surrounding card around.
 *
 * Pass `inline` for places where the field should sit beside other
 * inline content (badges, labels) — that mode renders without the
 * default block spacing entirely. Falsy/empty input renders the
 * `placeholder` text in muted style.
 */
export const Markup = ({ children, className = '', inline = false, placeholder = null }) => {

    const text = typeof children === 'string' ? children.replace(/\r/g, '').trim() : '';

    if (!text) {

        if (!placeholder) return null;
        return (
            <em className="text-muted">
                {placeholder}
            </em>
        );

    }

    return (
        <div className={`tr-markup ${inline ? 'tr-markup-inline' : ''} ${className}`}>
            <ReactMarkdown
                components={{
                    a: props => (
                        <a
                            {...props}
                            rel="noopener noreferrer"
                            target="_blank"
                        />
                    )
                }}
            >
                {text}
            </ReactMarkdown>
        </div>
    );

};
